module.exports = __webpack_public_path__ + "img/medical-materials-prescription.fba3a093.svg";